import {Card, Icon, Text} from '@ui-kitten/components';
import React from 'react';
import {Image, StyleSheet, View} from 'react-native';
import {useSelector} from 'react-redux';
import {getImage} from '../../../helpers/general';
import {getSubjectNameById, hp, px, wp} from '../../../utils';
import {renderIfElse} from '../../../utils/Utils';

const TimeTableRow = ({
  item,
  isLastIndex,
  isSelected,
  onSelect,
  disabled,
  useTimeTablePageStyle,
}) => {
  const {subjectId, startTime, endTime, weekDay} = item;
  const subjects = useSelector((state) => state.general.subjects);

  return (
    <Card
      disabled={disabled || typeof onSelect !== 'function'}
      onPress={() => {
        if (!disabled && typeof onSelect === 'function') {
          onSelect(item);
        }
      }}
      style={[
        styles.container,
        useTimeTablePageStyle
          ? {
              marginBottom: px(20),
              marginRight: px(24),
              width: wp(25),
              height: hp(20),
            }
          : {
              marginTop: px(7),
            },
        isLastIndex && styles.lastIndex,
        isSelected && styles.selected,
        disabled && styles.disabled,
      ]}>
      <View style={styles.body}>
        <View style={styles.leftCol}>
          <Text style={styles.primaryText}>
            {getSubjectNameById({id: subjectId, subjects})}
          </Text>
          {renderIfElse(
            item.teacherName,
            <Text style={styles.secondaryText}>{item.teacherName}</Text>,
            <Text style={styles.secondaryText}>{item.name}</Text>,
          )}
          <Text style={styles.secondaryText}>{weekDay}</Text>
          <Text style={styles.secondaryText}>
            {startTime + ' - ' + endTime}
          </Text>
        </View>
        <View style={styles.rightCol}>
          {renderIfElse(
            item.teacherImage,
            <Image
              source={{uri: getImage(item.teacherImage)}}
              resizeMode="contain"
              style={styles.image}
            />,
            <Image
              source={{uri: getImage(item.image)}}
              style={styles.image}
              resizeMode="contain"
            />,
          )}
        </View>
        {isSelected && (
          <Icon
            name="checkmark-circle-2"
            fill="#074EE8"
            style={styles.checkIcon}
          />
        )}
      </View>
    </Card>
  );
};

const styles = StyleSheet.create({
  container: {
    padding: px(10),
    borderWidth: px(2),
    borderColor: '#C2CFE0',
  },
  selected: {
    borderColor: '#074EE8',
  },
  checkIcon: {
    width: px(20),
    height: px(20),
    position: 'absolute',
    top: px(-5),
    right: px(0),
  },
  disabled: {
    backgroundColor: '#CCCCCC90',
  },
  lastIndex: {
    marginBottom: px(7),
  },
  body: {
    width: '100%',
    paddingVertical: px(5),
    flexDirection: 'row',
    justifyContent: 'space-between',
    position: 'relative',
  },
  leftCol: {
    flex: 1,
  },
  rightCol: {
    justifyContent: 'center',
    alignItems: 'flex-end',
    width: 70,
    paddingHorizontal: px(5),
  },
  image: {
    marginBottom: 0,
    width: 60,
    height: 60,
    borderRadius: 100,
    backgroundColor: '#FFEDEF',
  },
  primaryText: {
    fontSize: px(16),
    fontWeight: '600',
  },
  secondaryText: {
    fontSize: px(16),
    marginTop: px(6),
  },
});

export default TimeTableRow;
